module.exports = __webpack_public_path__ + "img/portfolio-05-480x343.e6b97c9b.jpg";